import { useGasStatus } from "@/hooks/useGasStatus";
import { ROUTES } from "@/lib/routes";
import { cn, formatNum } from "@/lib/utils";
import { Link } from "react-router-dom";

/** Bottom row: cycle / gas health. */
export function GasStatusRow() {
	const { data, isLoading } = useGasStatus();

	const tone =
		data?.label === "Critical"
			? "text-danger"
			: data?.label === "Low"
				? "text-warning"
				: "text-primary";

	return (
		<div className="border-t border-border bg-muted/40">
			<div className="container mx-auto flex flex-wrap items-center gap-x-4 gap-y-2 px-3 py-2.5 sm:px-4">
				<span className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">
					Gas status
				</span>

				{isLoading || !data ? (
					<span className="text-xs text-muted-foreground">Loading…</span>
				) : (
					<div className="flex min-w-0 flex-1 flex-wrap items-center gap-x-3 gap-y-1 text-xs">
						<span className={cn("font-semibold", tone)}>{data.label}</span>
						{data.opsAvailable ? (
							<span className="font-mono-amount">
								<span className="text-muted-foreground">Ops </span>
								{formatNum(data.opsCyclesT, 1)}T
							</span>
						) : null}
						<span className="font-mono-amount">
							<span className="text-muted-foreground">Protocol </span>
							{formatNum(data.protocolCyclesT, 1)}T
						</span>
						<span className="hidden text-[10px] text-muted-foreground sm:inline">
							{data.note}
						</span>
					</div>
				)}

				<Link
					to={ROUTES.cycles}
					className="text-[11px] font-semibold text-primary hover:underline"
				>
					Cycle Gas Station
				</Link>
			</div>
		</div>
	);
}
